/**
 * Agencies - All Projects Page
 * Agency and Marketing projects management
 */

import { useEffect } from 'react';
import { MainLayout } from "@/components/MainLayout";
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';

export default function ProjectsListPage() {
  useEffect(() => {
    document.title = 'Todos os Projetos | Controle Financeiro';
  }, []);

  return (
    <MainLayout>
      <div className="container mx-auto py-6">
        <AllProjectsPage
          domain={CompanyType.AGENCIES}
          title="Todos os Projetos"
          description="Gerencie seus projetos de marketing e publicidade"
          createButtonLabel="Novo Projeto"
        />
      </div>
    </MainLayout>
  );
}

